import { useState, useEffect } from 'react';
import { fetchAuthSession } from '../../../utils/authSession';

export const useAdminAuth = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  useEffect(() => {
    const checkSession = async () => {
      setIsLoading(true);
      try {
        const session = await fetchAuthSession();
        const accessToken = session.tokens?.accessToken;
        const groups = accessToken?.payload?.["cognito:groups"] || [];
        const convaiadmin_accessToken = sessionStorage.getItem("accessToken");

        if (
          groups.includes("ConvAI_Admin") &&
          convaiadmin_accessToken === accessToken.toString()
        ) {
          setIsAuthenticated(true);
        } else {
          // Wrong role for this admin tool (or a genuine mismatch) -- deny
          // locally only. Must NOT call signOut() here: it posts to
          // /api/auth/logout, which triggers Cognito's global_sign_out and
          // invalidates the session on every device, so one tab's local
          // "not authorized for this page" would otherwise log the user out
          // everywhere, not just here.
          sessionStorage.removeItem("accessToken");
          setIsAuthenticated(false);
        }
      } catch (err) {
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };
    checkSession();
  }, []);

  return { isLoading, isAuthenticated };
};